export const initialState = {
  tag: null,
  items: [],
}

export const setTag = (state, payload) => (
  { ...state, tag: payload }
)

export const setItems = (state, payload) => (
  { ...state, items: payload }
)

export const clear = () => initialState
